import { useSearchParams, useLocation, Navigate } from 'react-router-dom';
import { TestSessionView } from './TestSessionView';
import { TestHistoryView } from './TestHistoryView';

export default function Tests() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const showHistory = searchParams.get('tab') === 'history';

  // Legacy repair-intent links should now go to /repairs
  const prefillSessionType = location.state?.prefillSessionType;
  if (prefillSessionType === 'repair') {
    return (
      <Navigate
        to="/repairs"
        replace
        state={{ ...location.state }}
      />
    );
  }

  return (
    <div className="page page-tests">
      {showHistory ? <TestHistoryView /> : <TestSessionView />}
    </div>
  );
}
